import { getUsersProviders } from '@services/external/provider.api';
import { useQuery, UseQueryOptions } from 'react-query';

async function handler() {
  const { data } = await getUsersProviders();

  return data.data;
}

type TQueryData = Awaited<ReturnType<typeof handler>>;

function useUsersProviders(options?: UseQueryOptions<TQueryData, unknown, TQueryData, any[]>) {
  return useQuery(['provider:myProviders'], handler, options);
}

export default useUsersProviders;
